import React from 'react';
type FieldProps = {
  id: string;
  label: string;
  required?: boolean;
  showRequiredIndicator?: boolean;
  error?: string;
  type?: string;
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
};
export function Field({
  id,
  label,
  required,
  showRequiredIndicator = true,
  error,
  type = 'text',
  value,
  placeholder,
  onChange
}: FieldProps) {
  return <div data-id="element-61" data-mp="zdpxstf4glv1">
      <label htmlFor={id} className="mb-1.5 flex text-sm font-semibold text-[#041F60]" data-id="element-62" data-mp="zeivz600m31k">
        {label}
        {required && showRequiredIndicator && <span className="ml-1 text-rose-600" data-id="element-63" data-mp="pftirqj2d6rn">*</span>}
      </label>
      <input id={id} type={type} required={required} value={value} placeholder={placeholder} onChange={event => onChange(event.target.value)} aria-invalid={Boolean(error)} aria-describedby={error ? `${id}-error` : undefined} className={`block w-full max-w-full rounded-lg border bg-white px-3.5 py-3 text-base text-[#041F60] outline-none transition placeholder:text-stone-400 focus:border-[#041F60] focus:ring-2 focus:ring-[#4BE4FF] sm:text-sm ${error ? 'border-rose-500' : 'border-[#A6B6F8]/60'}`} data-id="element-64" data-mp="phwbwjfijg0l" />
      {error && <p id={`${id}-error`} className="mt-1.5 text-xs font-medium text-rose-600" data-id="element-65" data-mp="1l4kiggi6yj8g">
          {error}
        </p>}
    </div>;
}